<template>
  <div class="min-h-screen flex flex-col justify-center items-center pt-6 sm:pt-0 p-4">
    <logo />
    <umisis-login-form />
    <div class="text-center text-sm mt-4">
      {{ $t('login.footer_sign_up_message') }}
      <router-link :to="{ name: 'Register' }" class="underline text-gray-500 hover:text-gray-200">
        {{ $t('login.footer_sign_up_link') }}
      </router-link>
      <umisis-language-switcher class="float-right" />
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'
import { useAuthStore } from '@/stores/auth.js'
import { mapActions } from 'pinia'
import UmisisLoginForm from '@/components/umisis/auth/UmisisLoginForm.vue'
import UmisisLanguageSwitcher from '@/components/umisis/navigation/UmisisLanguageSwitcher.vue'

export default {
  components: {
    UmisisLanguageSwitcher,
    UmisisLoginForm,
    Logo
  },
  data: () => {
    return {
      errors: null,
      loading: null,
      email: null,
      password: null,
      remember: null
    }
  },
  methods: {
    ...mapActions(useAuthStore, ['attempt_user', 'set_user', 'login']),
    async loginSubmit () {
      try {
        this.errors = null
        this.loading = true
        await this.login(this.data)
        this.errors = false
      } catch (e) {
        console.error(e)
        this.loading = false
        if (e.response) this.errors = e.response.data
        throw e
      }
    }
  }
}
</script>
